<script>
    import Fa from 'svelte-fa'
    import { faCalculator, faCog, faFileInvoiceDollar, faRobot } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import AutomacaoManager from '../automacao/automacao-manager.svelte'
    import FinancialEntries from './financial-entries.svelte'
    import FinancialResults from './financial-results.svelte'
</script>

<Content>
    <div class="root-content">
        <div class="tab h-mobile">
            <Link class="link" href="/financial/entries"><Fa icon={faFileInvoiceDollar} /> Lançamentos</Link>
            {#if window.store.token.permissions.financial.reports.read}
                <Link class="link" href="/financial/results"><Fa icon={faCalculator} /> Resultado</Link>
            {/if}
            <div class="spacer" />
        </div>
        <div class="body">
            <Router>
                <Route path="/entries">
                    <FinancialEntries />
                </Route>
                <Route path="/results">
                    <FinancialResults />
                </Route>
            </Router>
        </div>
    </div>
</Content>

<style>
    .tab {
        color: rgb(var(--finan-color));
        border-bottom-color: rgb(var(--finan-color));
        border-bottom-width: 2px;
    }
    .tab :global([aria-current='page']) {
        background-color: rgba(var(--finan-color), 0.9);
    }

    @media (max-width: 900px) {
        .root {
            padding: 4px;
            padding-top: 8px;
        }
    }
</style>
